export default {
  approvalRequests: [],
  approvalRequest: undefined,
};
